import * as api from './index';

export function upsertTagConfigs(payload) {
    return api.put('/tag-configs', payload);
}
